import axios from 'axios';

// 登录请求方法
const loginreq = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: params,
        traditional: true,
        transformRequest: [
            function (data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};
// 通用公用方法
// const baseUrl = 'http://114.100.63.118:28780/center'
const baseUrl = process.env.BASE_API

const req = (method, url, params) => {
    return axios({
        method: method,
        url: baseUrl + url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
        transformRequest: [
            function (data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};

// 通用公用方法
const mapbaseUrl = 'https://restapi.amap.com/v3'
const mapreq = (method, url, params) => {
    return axios({
        method: method,
        url: mapbaseUrl + url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
        transformRequest: [
            function (data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};

// 支付公用方式
const alipayReq = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/json',
            // token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
        // transformRequest: [
        //     function (data) {
        //         let ret = ''
        //         for (let it in data) {
        //             ret +=
        //                 encodeURIComponent(it) +
        //                 '=' +
        //                 encodeURIComponent(data[it]) +
        //                 '&'
        //         }
        //         return ret
        //     }
        // ]
    }).then(res => res.data);
};

const reqGet = (method, url, params) => {
    let ret = ''
    for (let it in params) {
        ret +=
            encodeURIComponent(it) +
            '=' +
            encodeURIComponent(params[it]) +
            '&'
    }
    return axios({
        method: method,
        url: baseUrl + url + `?${ret}`,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
        transformRequest: [  // 这个更改请求参数只能作用与 put post 和PATCH请求方法
             (data)=> {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};

const jsonReq = (method, url, params) => {
    return axios({
        method: method,
        url: baseUrl + url,
        headers: {
            'Content-Type': 'application/json',
            // token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
    }).then(res => res.data);
};

export {
    loginreq,
    req,
    mapreq,
    alipayReq,
    reqGet,
    jsonReq
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js